import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './style/iconfont.css'
import '@/utils/rem.js'
import './fontss/fontss.css'

Vue.config.productionTip = false


new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
